import { ERentioFormField } from "@rentiohq/shared-frontend/dist/components/components/Form";
import { getValue } from "@rentiohq/shared-frontend/dist/redux/form/form.utils";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import { ts } from "../../../../services";
import { EField } from "./schema.editContact.types";
export var getSchema = function (initialValues, _a) {
    var contact = _a.contact;
    return function (defaultValues) {
        var _a;
        return ({
            required: [],
            properties: (_a = {},
                _a[EField.EnableInvoicing] = {
                    type: "boolean",
                    default: getValue(EField.EnableInvoicing, initialValues, defaultValues),
                },
                _a),
        });
    };
};
export var uiSchema = function (extraData) {
    var _a;
    return (_a = {
            "rentio:navigationTitle": ts.contactEditContact(),
            "rentio:trackingKey": "contact_edit"
        },
        _a[EField.EnableInvoicing] = {
            "ui:field": ERentioFormField.Switch,
            label: getLocalizedText("contact.enable_invoicing.label"),
        },
        _a);
};
